import React from 'react';

// LOCAL DEPENDECIES
import { memberAddEditPaymentInformation as MemberAddEditPaymentInformationView } from 'ui/views/widgets/memberAddEditPaymentInformation';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import { getStore } from 'store';
import { REDUCER } from 'constants/entity-names';
import { split, trim, isEmpty, get } from 'lodash';
import { overlay } from 'modules/overlay';
import { OVERLAY_VIEWS } from 'constants/templates';

// get store
const store = getStore();

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberAddEditPaymentInformation } from 'ui/containers/MemberAddEditPaymentInformation';
 *
 * // render
 * <MemberAddEditPaymentInformation propName='propValue'/>
 */
class _MemberAddEditPaymentInformation extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.state = {
            isFetching: false,

            // edit mode state
            isEditing: false,
            editingCardId: null,
            editingExpiryMonth: null,
            editingExpiryYear: null,

            // clearSelectionSelected: false
        };

        // bind events and methods
        this.__bind();
    }

    /**
     * @desc Bind events and methods to the instance.
     */
    __bind() {
        this.handleSetDefaultAction = this.handleSetDefaultAction.bind( this );
        this.initiateAddPaymentInfo = this.initiateAddPaymentInfo.bind( this );
        this.handleSelection = this.handleSelection.bind( this );
        this.handleEditAction = this.handleEditAction.bind( this );
        this.handleActivationAction = this.handleActivationAction.bind( this );
        this.handleInactivateAction = this.handleInactivateAction.bind( this );
        this.handleCancelEdit = this.handleCancelEdit.bind( this );
        this.handleCardMonthSelect = this.handleCardMonthSelect.bind( this );
        this.handleCardYearSelect = this.handleCardYearSelect.bind( this );
        this.handleSubmitEditedCardDetails = this.handleSubmitEditedCardDetails.bind( this );
        this.handleHsaFsaAction = this.handleHsaFsaAction.bind( this );
    }

    initiateAddPaymentInfo( { url } ) {
        log.debug( 'MemberAddEditPaymentInformation.initiateAddPaymentInfo()' );

        // get payment portal url
        const URLS = store.getState()[ REDUCER.URLS ];
        const portalUrl = URLS[ url.refId ];

        // get return url from `addCardParams`
        const { returnUrl, ...queryParams } = this.props.addCardParams;

        const redirectPath =  queryString.stringifyUrl( {
            url: portalUrl,
            query: {
                returnUrl: queryString.stringifyUrl( {
                    url: returnUrl,
                    query: {
                        ...queryParams,
                        path: this.props.addPaymentRedirectPath,
                    },
                } )
            }
        } );
        
        // change browser location
        window.location.href = redirectPath;
    }

    /**
     * @desc: action executed when user selects an address
     */
    handleSelection( { card } ) {
        log.debug( 'MemberAddEditPaymentInformation.handleSelection()' );

        // update the selection to parent container

        // this.setState( { clearSelectionSelected: false }, () => {

            this.props.onPaymentOptionSelection( { card } );
        
        // } );
    }

    /**
     * @desc: action executed when MSR clicks on edit action
     */
    handleEditAction( { card } ) {
        log.debug( 'MemberAddEditPaymentInformation.handleEditAction()' );

        //const action = find( this.props.modifyActions, { name: 'edit' } );
        //const isDefault = get( card, 'flags.isDefault', false );

        // get month and year from the expiry date
        const [ expiryMonth, expiryYear ] = split( card.expDate, '/' );

        this.setState( {
            isEditing: true,
            editingCardId: card.id,
            editingExpiryMonth: trim( expiryMonth ),
            editingExpiryYear: trim( expiryYear ),
        } );
    }

    /**
     * @desc Cancel edit mode
     */
    handleCancelEdit() {
        log.debug( 'MemberAddEditPaymentInformation.handleCancelEdit()' );

        this.setState( {
            isEditing: false,
            editingCardId: null,
            editingExpiryMonth: null,
            editingExpiryYear: null,
        } );
    }

    /**
     * @desc When month is changed in the editing mode
     */
    handleCardMonthSelect( { value } = {} ) {
        log.debug( 'MemberAddEditPaymentInformation.handleCardMonthSelect()' );

        this.setState( {
            editingExpiryMonth: value,
        } );
    }

    /**
     * @desc When year is changed in the editing mode
     */
    handleCardYearSelect( { value } = {} ) {
        log.debug( 'MemberAddEditPaymentInformation.handleCardYearSelect()' );

        this.setState( {
            editingExpiryYear: value,
        } );
    }

    /**
     * @desc When user clicks on the checkmark action
     */
    handleSubmitEditedCardDetails( { card } ) {
        log.debug( 'MemberAddEditPaymentInformation.handleSubmitEditedCardDetails()' );

        this.props.onPaymemntInfoEdit( {
            card,
            month: this.state.editingExpiryMonth,
            year: this.state.editingExpiryYear,
        }, () => {
            this.setState( {
                isEditing: false,
                editingCardId: null,
                editingExpiryMonth: null,
                editingExpiryYear: null,
            } );
        } );
        
    }

    /**
     * @desc action executed when MSR clicks on activate action
     */
    handleActivationAction( { card } ) {
        log.debug( 'MemberAddEditPaymentInformation.handleActivationAction()' );

        this.props.onPaymemntInfoActivate( { card } );
    }

    /**
     * @desc: action executed when MSR clicks on inactivate action
     */
    handleInactivateAction( { card } ) {
        log.debug( 'MemberAddEditPaymentInformation.handleInactivateAction()' );

        this.props.onPaymemntInfoInactivate( { card } );
    }

    // when user updates the default selection
    handleSetDefaultAction( { card } ) {
        log.debug( 'MemberAddEditPaymentInformation.handleSetDefaultAction()' );

        if ( !isEmpty( get( this.props, 'defaultDescription', {} ) ) ) {
            overlay.open( {
                settings: {
                    modalType: OVERLAY_VIEWS.CHANGE_DEFAULT_CONFIRM,
                    showCloseButton: false,
                    ignoreOutsideClick: false,
                },
                config: {},
                data: {
                    ...this.props.changeConfirmation,
                    onSumbitClick: async ( ) => {
    
                        overlay.close();
                        this.props.onPaymentDefaultSelection( { card } );
    
                    },
                    onCancelClick: () => {
                        overlay.close();
                    },
                },
            } );
        } else{
            this.props.onPaymentDefaultSelection( { card } );
        }
        
    }

    /**
     * @desc action executed when MSR clicks on hsaFsa action
     */
     handleHsaFsaAction( { url, card } ) {
        log.debug( 'MemberAddEditPaymentInformation.handleHsaFsaAction()' );

        this.props.onHsaFsaActionToggle( { url, ...card } );
    }

    /*****************************************/

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <MemberAddEditPaymentInformationView
                { ...this.state }
                { ...this.props }
                onAddActionClick={ this.initiateAddPaymentInfo }
                onSetDefaultClick={ this.handleSetDefaultAction }
                onSelectActionClick={ this.handleSelection }
                onEditActionClick={ this.handleEditAction }
                onActivateActionClick={ this.handleActivationAction }
                onInactivateActionClick={ this.handleInactivateAction }
                onCancelEdit={ this.handleCancelEdit }
                onCardMonthSelect={ this.handleCardMonthSelect }
                onCardYearSelect={ this.handleCardYearSelect }
                onSubmitEditedCardDetails={ this.handleSubmitEditedCardDetails }
                onHsaFsaActionClick={ this.handleHsaFsaAction }

                // editing props
                isEditing={ this.state.isEditing }
                editingCardId={ this.state.editingCardId }
                editingExpiryMonth={ this.state.editingExpiryMonth }
                editingExpiryYear={ this.state.editingExpiryYear }
            />
        );
    }
}

// set display name
_MemberAddEditPaymentInformation.displayName = 'MemberAddEditPaymentInformation';

// set default props
_MemberAddEditPaymentInformation.defaultProps = {
    addPaymentRedirectPath: '/route/checkout-complete', // this should be the route path of the frontend application used by backend to return to the application
};

// prop types
_MemberAddEditPaymentInformation.propTypes = {};

export const MemberAddEditPaymentInformation = withRouter(  _MemberAddEditPaymentInformation  );
